import * as PhosphorIcons from '@phosphor-icons/react';
export { UserCircleIcon } from '@phosphor-icons/react';

const ICON_MAPPING = {
  GraduationCapIcon: PhosphorIcons.GraduationCapIcon,
  UsersIcon: PhosphorIcons.UsersIcon,
  UsersThreeIcon: PhosphorIcons.UsersThreeIcon,
  UsersFourIcon: PhosphorIcons.UsersFourIcon,
};

const FALLBACK_SEGMENTS = {
  // topper: {
  //   title: 'Topper',
  //   icon: 'GraduationCapIcon',
  //   key: 'topper',
  // },
  top_10_percent: {
    title: 'Top 10%ile',
    icon: 'UsersIcon',
    key: 'top_10_percent',
  },
  top_25_percent: {
    title: 'Top 25%ile',
    icon: 'UsersThreeIcon',
    key: 'top_25_percent',
  },
  //   average: {
  //     title: 'Average',
  //     icon: 'UsersFourIcon',
  //     key: 'average',
  //   },
};

/**
 * Dynamically resolve icon name string to icon component
 * @param {string} iconName - Icon name from API (e.g., 'GraduationCapIcon')
 * @returns {React.Component} - Icon component
 */
const resolveIcon = (iconName) => {
  return PhosphorIcons[iconName] || PhosphorIcons.UsersIcon;
};

/**
 * Get normalized segments with resolved icon components
 * If comparativeSegmentsMeta exists, use it
 * Otherwise, use fallback segments
 *
 * @param {Object} comparativeSegmentsMeta - New API segment metadata
 * @returns {Object} - Normalized segments with resolved icon components
 */
export const getNormalizedSegments = (comparativeSegmentsMeta) => {
  if (comparativeSegmentsMeta && Object.keys(comparativeSegmentsMeta).length > 0) {
    return Object.entries(comparativeSegmentsMeta).reduce((acc, [key, meta]) => {
      acc[key] = {
        ...meta,
        key,
        icon: resolveIcon(meta.icon),
      };
      return acc;
    }, {});
  }

  return Object.entries(FALLBACK_SEGMENTS).reduce((acc, [key, segment]) => {
    acc[key] = {
      ...segment,
      icon: resolveIcon(segment.icon),
    };
    return acc;
  }, {});
};

/**
 * Get array of segments in order, excluding specific keys if needed
 * @param {Object} segments - Normalized segments
 * @param {Array} excludeKeys - Keys to exclude from the result
 * @returns {Array} - Array of segment objects
 */
export const getSegmentsArray = (segments, excludeKeys = []) => {
  return Object.entries(segments)
    .filter(([key]) => !excludeKeys.includes(key))
    .map(([key, segment]) => ({
      ...segment,
      key,
    }));
};

/**
 * Get single segment by key
 * @param {Object} segments - Normalized segments
 * @param {string} key - Segment key
 * @returns {Object} - Segment object
 */
export const getSegmentByKey = (segments, key) => {
  return segments[key];
};
